import React from 'react';
import { useStyles } from '~atoms/BetslipKeyboardButtons/BetslipKeyboardButtons.styles';
export var MinusPlusKeyboardButton = function (_a) {
    var onPlusClick = _a.onPlusClick, onMinusClick = _a.onMinusClick;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.minusPlusButton },
        React.createElement("div", { role: "button", tabIndex: 0, className: classes.minusButton, onClick: onMinusClick }, "-"),
        React.createElement("div", { role: "button", tabIndex: 0, className: classes.plusButton, onClick: onPlusClick }, "+")));
};
